import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store'

import RegisterIcon from './RegisterIcon.vue'
import MypageIcon from './MypageIcon.vue'
import RegisterAdditionalModal from './RegisterAdditionalModal.vue'
import CallDownloadLink from './CallDownloadLink.vue'
import ChangeMembership from './ChangeMembership.vue'
import RegisterAuthCode from './RegisterAuthCode.vue'
import ReLogin from './ReLogin.vue'

import Loginicon from './Loginicon.vue'
import LoginiconWebform from './LoginiconWebform.vue'
import LoginCheckPage from './LoginCheckPage.vue'
import Logouticon from './Logouticon.vue'
import RenewalUserModal from './RenewalUserModal.vue'
import RegisterAdditionalModalComplete from './RegisterAdditionalModalComplete.vue'
import Mypagetop from './Mypagetop.vue'
import Mypagedownload from './Mypagedownload.vue'
import Mypagebookmark from './Mypagebookmark.vue'
import BookmarkInPage from './BookmarkInPage.vue'
import BookmarkMobile from './BookmarkMobile.vue'
import UserName from './UserName.vue'
import SpecialAccess from './SpecialAccess.vue'
import VueFilter from '../../modules/filter/VueFilter'
import MypageEquipTop from './MypageEquipTop.vue'
import ErrorModal from './ErrorModal.vue'

// 翻訳
import VueI18n from 'vue-i18n'
import Translate from './translation/Translate'

Vue.use(VueI18n)
const i18n = new VueI18n(Translate)
Vue.config.productionTip = false

Vue.use(VueRouter)

// 本番運用の際は必ずtrueにしてください
Vue.config.silent = false
// membershipcontrollにあるインスタンスをhtmlで使用しなかった場合に、
// warningが表示されてしまいます
// 警告の例） vue.runtime.esm.js:619 [Vue warn]: Cannot find element: #vue_register_complete

Vue.filter('number_format', VueFilter.numberFormat)

// グローバル変数で会員機能を利用することを宣言する
window.iwgp.useMemberShip = true

if (document.getElementById('vue_register_icon') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(RegisterIcon)
  }).$mount('#vue_register_icon')
}

if (document.getElementById('vue_mypage_icon') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(MypageIcon)
  }).$mount('#vue_mypage_icon')
}

if (document.getElementById('vue_register_additional_modal') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(RegisterAdditionalModal)
  }).$mount('#vue_register_additional_modal')
}

if (
  document.getElementById('vue_register_additional_modal_complete') !== null
) {
  new Vue({
    i18n,
    store,
    render: (h) => h(RegisterAdditionalModalComplete)
  }).$mount('#vue_register_additional_modal_complete')
}

if (document.getElementById('vue_change_membership') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(ChangeMembership)
  }).$mount('#vue_change_membership')
}

if (document.getElementById('vue_login_icon') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(Loginicon)
  }).$mount('#vue_login_icon')
}

if (document.getElementById('vue_login_icon_webform') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(LoginiconWebform)
  }).$mount('#vue_login_icon_webform')
}

if (document.getElementById('vue_login_check_page') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(LoginCheckPage)
  }).$mount('#vue_login_check_page')
}

if (document.getElementById('vue_logout_icon') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(Logouticon)
  }).$mount('#vue_logout_icon')
}

if (document.getElementById('vue_RenewalUserModal_modal') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(RenewalUserModal)
  }).$mount('#vue_RenewalUserModal_modal')
}

if (document.getElementById('vue_mypage_top') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(Mypagetop)
  }).$mount('#vue_mypage_top')
}

if (document.getElementById('vue_mypage_download') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(Mypagedownload)
  }).$mount('#vue_mypage_download')
}

if (document.getElementById('vue_mypage_bookmark') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(Mypagebookmark)
  }).$mount('#vue_mypage_bookmark')
}

if (document.getElementById('vue_bookmark_in_page') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(BookmarkInPage)
  }).$mount('#vue_bookmark_in_page')
}

if (document.getElementById('vue_bookmark_mobile') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(BookmarkMobile)
  }).$mount('#vue_bookmark_mobile')
}

if (document.getElementById('vue_user_name') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(UserName)
  }).$mount('#vue_user_name')
}

if (document.getElementById('vue_special_access') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(SpecialAccess)
  }).$mount('#vue_special_access')
}

if (document.getElementById('vue_call_download_link') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(CallDownloadLink)
  }).$mount('#vue_call_download_link')
}

// VueRouter
const router = new VueRouter({
  mode: 'history'
})

if (document.getElementById('vue_register_auth_code') !== null) {
  new Vue({
    i18n,
    store,
    router,
    render: (h) => h(RegisterAuthCode)
  }).$mount('#vue_register_auth_code')
}

if (document.getElementById('vue_relogin') !== null) {
  new Vue({
    i18n,
    store,
    router,
    render: (h) => h(ReLogin)
  }).$mount('#vue_relogin')
}

if (document.getElementById('vue_mypage_equip_top') !== null) {
  new Vue({
    i18n,
    store,
    render: (h) => h(MypageEquipTop)
  }).$mount('#vue_mypage_equip_top')
}

if (document.getElementById('vue_error_modal') !== null) {
  new Vue({
    i18n,
    store,
    router,
    render: (h) => h(ErrorModal)
  }).$mount('#vue_error_modal')
}
